/**
 * @generated SignedSource<<e23be07fd95343baa6f7217b5094530b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_item$data = {
  readonly internalBuyLinks: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
  } | null> | null;
  readonly isAuctionEnabled: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_seller">;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedBreadcrumbs_item" | "PdpRespSharedHeroCarouselPrint_item" | "PdpRespSharedHeroCarousel_item" | "PdpRespSharedPrintDetailsLazy_item" | "PdpRespSharedSidebarSellerInfoAndContact_item" | "PdpRespSharedTitle_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespUnavailableDetailsTabs_item" | "PdpRespUnavailableHeader_item" | "PdpSharedAuctionClosed_item" | "PdpSharedEditorialArticles_refactor_item" | "PdpSharedItemFavorites_item" | "PdpSharedSellerItemsCarousel_item" | "PdpSharedUnavailableViewPrice_item" | "PdpSharedYMALItemsCarousel_item" | "PriceDisplay_item" | "SharedRespLinksBlock_item" | "usePdpSharedTracking_item">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_item";
};
export type PdpRespUnavailableContainer_item$key = {
  readonly " $data"?: PdpRespUnavailableContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBuaSsr"
    },
    {
      "kind": "RootArgument",
      "name": "isSoldPDPV1Variant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        },
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedSidebarSellerInfoAndContact_seller"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "kind": "LinkedField",
      "name": "internalBuyLinks",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedRespLinksBlock_links"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpSharedTracking_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedBreadcrumbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedEditorialArticles_refactor_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionClosed_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedItemFavorites_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarouselPrint_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSidebarSellerInfoAndContact_item"
        }
      ]
    },
    {
      "condition": "afterDisplayOrBuaSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PriceDisplay_item"
        }
      ]
    },
    {
      "condition": "isSoldPDPV1Variant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsLanding_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedYMALItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedUnavailableViewPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "c4ae60aabdb8381b9fec62738c0add1e";

export default node;
